import { Injectable } from '@angular/core';
import { HttpService } from '../app/utility/http-service';

@Injectable({ providedIn: 'root' })
export class RolesService {
  private readonly base = 'Roles';

  constructor(private http: HttpService) {}

  getAvailableUserRoles(onSuccess: (roles: string[]) => void): void {
    this.http.get<string[]>(`${this.base}/GetAvailableUserRoles`, onSuccess, true);
  }

  getAvailableClientRoles(onSuccess: (roles: string[]) => void): void {
    this.http.get<string[]>(`${this.base}/GetAvailableClientRoles`, onSuccess, true);
  }

  getUserRoles(userId: string, onSuccess: (roles: string[]) => void): void {
    this.http.get<string[]>(`${this.base}/GetUserRoles?userId=${encodeURIComponent(userId)}`, onSuccess, true);
  }

  addUserRole(userId: string, roleName: string, onSuccess: () => void): void {
    this.http.postReturn(
      `${this.base}/AddUserRole?userId=${encodeURIComponent(userId)}&roleName=${encodeURIComponent(roleName)}`,
      onSuccess, undefined, {});
  }

  removeUserRole(userId: string, roleName: string, onSuccess: () => void): void {
    this.http.deleteReturn(
      `${this.base}/RemoveUserRole?userId=${encodeURIComponent(userId)}&roleName=${encodeURIComponent(roleName)}`,
      onSuccess);
  }

  getClientRoles(clientId: string, onSuccess: (roles: string[]) => void): void {
    this.http.get<string[]>(`${this.base}/GetClientRoles?clientId=${encodeURIComponent(clientId)}`, onSuccess, true);
  }

  addClientRole(clientId: string, roleName: string, onSuccess: () => void): void {
    this.http.postReturn(
      `${this.base}/AddClientRole?clientId=${encodeURIComponent(clientId)}&roleName=${encodeURIComponent(roleName)}`,
      onSuccess, undefined, {});
  }

  removeClientRole(clientId: string, roleName: string, onSuccess: () => void): void {
    this.http.deleteReturn(
      `${this.base}/RemoveClientRole?clientId=${encodeURIComponent(clientId)}&roleName=${encodeURIComponent(roleName)}`,
      onSuccess);
  }
}
